import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconWrite3: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconWrite3"><Path d="M19.8564 12.8096L20.0957 13.1406L19.9482 13.5215L17.2568 20.4502H19.999V22.0498H3.99902V20.4502H6.74121L4.0498 13.5215L3.90234 13.1406L4.1416 12.8096L11.249 3.00684V11.6143C10.2347 11.9328 9.49902 12.8806 9.49902 14C9.49902 15.3807 10.6183 16.5 11.999 16.5C13.3797 16.5 14.499 15.3807 14.499 14C14.499 12.8806 13.7633 11.9328 12.749 11.6143V3.00684L19.8564 12.8096Z" fill="currentColor"/></CentralIconBase>;
});

export default IconWrite3;
